import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksRecomendedEquipment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT].GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT,
	},
}